import script from "./ParticipantVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./ParticipantVideo.vue?vue&type=script&setup=true&lang=js"

import "./ParticipantVideo.vue?vue&type=style&index=0&id=12e3b13e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12e3b13e"]])

export default __exports__